import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=561d2631&"
import script from "./Overview.vue?vue&type=script&setup=true&lang=js&"
export * from "./Overview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=561d2631&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports